'use client';
import React, { memo } from 'react';
import useApplyLogging from '../../hooks/useApplyLogging.mjs';

function IcShare(customProps) {
  const {
    fill,
    ...props
  } = customProps;
  useApplyLogging('ICON_IcShare');
  return /*#__PURE__*/React.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.146 2.08264C13.4846 1.93629 13.8792 2 14.1521 2.24505L23.6967 10.8997C23.8899 11.0732 24 11.3185 24 11.5755C24 11.8325 23.89 12.0777 23.6967 12.2513L14.1418 20.7552C13.8689 21.0002 13.4742 21.064 13.1357 20.9176C12.7972 20.7713 12.5787 20.4425 12.5787 20.0794V15.7364C11.5335 15.7968 9.90556 15.9761 8.21419 16.4894C5.73914 17.6048 3.506 18.8998 2.33847 21.3099C1.78333 22.4718 -0.0845228 22.0939 0.00297411 20.7199L0.00329722 20.7151C0.128792 18.8997 0.655463 15.5868 2.5855 12.9055C4.44198 10.3265 7.53836 8.07426 12.589 7.26215L12.589 2.92082C12.589 2.55777 12.8075 2.22899 13.146 2.08264ZM14.4554 5.00006L14.4554 8.05442C14.4554 8.51552 14.1062 8.90473 13.6401 8.96298C8.58941 9.59413 5.74316 11.6935 4.10987 13.9625C3.20003 15.2265 2.64687 16.9395 2.31422 18.1658C3.84932 16.595 5.83446 15.2941 7.66289 14.7393C10.2759 13.9464 12.7219 13.8754 13.5119 13.8754C14.0273 13.8754 14.4451 14.2855 14.4451 14.7913V18L21.6843 11.5756L14.4554 5.00006Z",
    fill: fill || '#1E1E23'
  }));
}
var IcShare$1 = /*#__PURE__*/memo(IcShare);

export { IcShare$1 as default };
